import { styled } from '@mui/material';

export const StyledBackground = styled('div')(() => ({
  background: `url(/assets/background/auth-bg.png) center center/cover`,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
}));
